'use es6';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import I18n from 'I18n';
import VizExCheckbox from 'visitor-ui-component-library/input/VizExCheckbox';
import VizExSmall from 'visitor-ui-component-library/typography/VizExSmall';
import { formatHtml } from 'sanitize-text/sanitizers/HtmlSanitizer';
import { jsx as _jsx } from "react/jsx-runtime";
const BreakString = styled.div.withConfig({
  displayName: "ConsentToCommunicate__BreakString",
  componentId: "nqk121-0"
})(["-ms-word-break:break-all;display:block;word-break:break-word;word-wrap:break-word;"]);
const SmallNoParagraphPadding = styled(VizExSmall).withConfig({
  displayName: "ConsentToCommunicate__SmallNoParagraphPadding",
  componentId: "nqk121-1"
})(["p{margin-bottom:0;}"]);
const ConsentToCommunicate = ({
  message,
  companyName,
  consentToCommunicate,
  onChange
}) => {
  const cleanMessage = formatHtml(message) || I18n.text('conversations-visitor-message-history.email-capture.consentToCommunicate', {
    accountName: companyName
  });
  /* eslint-disable  react/no-danger */
  return /*#__PURE__*/_jsx(VizExCheckbox, {
    checked: consentToCommunicate,
    onChange: onChange,
    children: /*#__PURE__*/_jsx(SmallNoParagraphPadding, {
      use: "help",
      children: /*#__PURE__*/_jsx(BreakString, {
        children: /*#__PURE__*/_jsx("span", {
          dangerouslySetInnerHTML: {
            __html: cleanMessage
          }
        })
      })
    })
  });
};
ConsentToCommunicate.displayName = 'ConsentToCommunicate';
ConsentToCommunicate.propTypes = {
  companyName: PropTypes.string,
  consentToCommunicate: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};
export default ConsentToCommunicate;